import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

import { BrandService } from "src/services/brand.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-brand-card",
  templateUrl: "./brand-card.component.html",
})
export class BrandCardComponent implements OnInit {
  imgSrc?: string;

  constructor(public brandService: BrandService) {}

  ngOnInit(): void {
    const urlShort = this.brandService.brand?.urlShort;
    if (urlShort) this.imgSrc = `assets/img/brand-card/${urlShort}.jpg`;
  }
}
